/* eslint-disable react/prop-types */
import React from 'react';

// componentes
import { Grid } from '@design-system-coopeuch/web';
import Skeleton from '../../atoms/Skeleton/Skeleton';

const SkeletonInputCodeSMS = (props) => {
  const { device } = props;

  return (
    <>
      {device === 'mobile' && (
        <Grid className="p-0">
          <Skeleton height="24px" width="100%" mb={8} />
          <Skeleton height="56px" width="100%" mb={8} />
          <Skeleton height="24px" width="100%" mb={8} />
        </Grid>
      )}
      {device === 'desktop' && (
        <Grid>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </Grid>
      )}
    </>
  )
};

Skeleton.defaultProps = {};
Skeleton.propTypes = {};

export default SkeletonInputCodeSMS;
